import api from '@/helpers/api'
import qs from 'qs'

export default {
  getPenjualanObat (data) {
    return api.get('/penjualan_obat?' + qs.stringify(data))
  },
  getPenjualanObatDetail (id) {
    return api.get('/penjualan_obat/' + id)
  },
  addPenjualanObat (obat) {
    return api.post('/penjualan_obat', obat)
  },
  updatePenjualanObat (id, obat) {
    return api.patch('/penjualan_obat/' + id, obat)
  },
  deletePenjualanObat (id) {
    var data = []
    return api.delete('/penjualan_obat/' + id, qs.stringify(data))
  }
}
